module.exports = __webpack_public_path__ + "static/img/search_bg.49e7d60c.png";